module.exports = __webpack_public_path__ + "static/media/newsite.57b91e68.jpg";